import { areTheSameDates, formatDateDisplay } from 'utils/datetime';

/**
 * @typedef {object} DateRangeValue
 * @property {string} from ISO-8601.
 * @property {string} to ISO-8601.
 */

/**
 * Turn a store `departureRange` value into the string shown in the input.
 * Empty/undefined input yields an empty string (input is left blank).
 *
 * @param {DateRangeValue | null | undefined} range
 * @returns {string}
 */
export const formatDateRangeLabel = (range) => {
	if (!range) return '';
	const { from, to } = range;
	if (areTheSameDates(from, to)) {
		return formatDateDisplay(from, { style: 'dotted' });
	}
	return `${formatDateDisplay(from, { style: 'dotted' })} - ${formatDateDisplay(to, { style: 'dotted' })}`;
};
